<template>
    <div class="row app">
        <menu-aplicacoes></menu-aplicacoes>

        <div class="content-app">

            <div class="topo"></div>

            <section id="app">
                <router-view></router-view>
            </section>

        </div>
    </div>
</template>

<script>
import MenuAplicacoes from '@/components/MenuAplicacoes'
import config from '@/util/configuracao.js'
import { carregarHeader } from '@/auth/auth.js'

window.introJS = require('intro.js').introJs

export default {
    name: 'app',
    components:{
        MenuAplicacoes
    },
    mounted: function() {
       
        carregarHeader()
    }
}
</script>

<style>
.app{
    padding:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?3d76113f